import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery, transformErrorResponse, transformErrorResponseWithMessage, transformResponse } from "../../baseQuery";

export const EducationLoanApiSlice = createApi({
    reducerPath: "EducationLoanApiSlice",
    baseQuery,

    tagTypes: ["globalPartnersUser", "educationpagination", ""],

    endpoints: (builder) => ({

        getGlobalPartnersUserApi: builder.query({
            query: () => ({
                url: 'educationLoan/getGlobalPartnersUser',
                method: "GET",
            }),
            transformResponse,
            transformErrorResponse: transformErrorResponseWithMessage,
            providesTags: ["globalPartnersUser"]
        }),


        getGlobalPartnersuserPagination: builder.query({
            query: ({ page = 1, limit = 3,destinationId }) => ({
                url: `educationLoan/getGlobalPartnersuserPagination`,
                method: 'GET',
                params: { page, limit,destinationId },
            }),
            transformResponse,
            transformErrorResponse: transformErrorResponseWithMessage,
            providesTags: ["educationpagination"]
        }),

    }),
});

export const {
    useGetGlobalPartnersUserApiQuery,
    useGetGlobalPartnersuserPaginationQuery
} = EducationLoanApiSlice; 